export * from "./DailyQuote";
